<template>
    <div class="form-input form-input-image">
        <div class="form-input-header">
            <div class="label">
                <img src="@/assets/images/icn-label-image.svg" :alt="label"/>{{ label }}
            </div>
            <div v-if="note" class="note">{{ note }}</div>
        </div>
        <div class="form-input-field-image">
            <div :class="{ 'file-box': true, empty: isEmpty }">
                <div v-if="isEmpty" class="file-box-icon"></div>
                <div v-if="isEmpty" class="file-box-info">
                    {{ $t('components.input.image.drag_image_here') }}<br/>
                    {{ $t('components.input.image.or') }}
                </div>
                <div v-if="isEmpty" class="file-box-button">{{ $t('components.input.image.browse') }}</div>
                <img v-if="!isEmpty" :src="url" class="file-box-image"/>
                <input
                    type="file"
                    class="file-box-input"
                    @change="hanldeChange"
                />
            </div>
            <div class="file-details">
                <div class="title">{{ $t('components.input.image.image_specification') }}</div>
                <ul v-if="spec_type || spec_format || spec_dimm">
                    <li v-if="spec_type"><span class="name">{{ $t('components.input.image.image_type') }}:</span><span class="value">{{ spec_type }}</span></li>
                    <li v-if="spec_format"><span class="name">{{ $t('components.input.image.format') }}:</span><span class="value">{{ spec_format }}</span></li>
                    <li v-if="spec_dimm"><span class="name">{{ $t('components.input.image.dimmensions') }}:</span><span class="value">{{ spec_dimm }}</span></li>
                </ul>
                <div v-if="!isEmpty" class="buttons">
                    <span @click="handleDelete">{{ $t('components.input.image.delete') }}</span>
                </div>
            </div>
        </div>
        <div v-if="errorHas" class="form-input-error">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import api from '@/api';

/* eslint-disable no-alert */
export default {
    name: 'InputText',
    props: {
        field: {
            type: String,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        note: {
            type: String,
            required: false,
        },
        spec_type: {
            type: String,
            required: false,
        },
        spec_format: {
            type: String,
            required: false,
        },
        spec_dimm: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            file: null,
            fileUrl: null,
        };
    },
    computed: {
        fieldId() {
            return `${ this.field }id`;
        },
        errorHas() {
            return this.errors && typeof this.errors[this.field] !== 'undefined' && this.errors[this.field];
        },
        errorMessage() {
            return this.errors[this.field].join('<br/>');
        },
        url() {
            if (this.fileUrl !== null) {
                return this.fileUrl;
            }

            if (typeof this.element[this.fieldId] !== 'undefined' && this.element[this.fieldId] && this.element[this.fieldId] > 0) {
                return api.image.url(this.element[this.fieldId]);
            }

            return null;
        },
        isEmpty() {
            return this.url === null;
        },
    },
    methods: {
        handleDelete() {
            this.file = null;
            this.fileUrl = null;
            Vue.delete(this.element, this.field);
            Vue.delete(this.element, this.fieldId);
        },
        hanldeChange(event) {
            if (!event.target.files || !event.target.files[0]) {
                alert('Missing file');
                return;
            }

            const file = event.target.files[0];
            if (!file) {
                alert('Missing file');
                return;
            }

            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                alert('Wrong file type');
                return;
            }

            this.file = file;
            this.fileUrl = window.URL.createObjectURL(file);
            this.element[this.field] = file;
        },
    },
};
</script>
